/**
 * 头部交互的渐进增强。
 *
 * 下拉和抽屉本体是原生 <details>,没有这段脚本一样能开合、一样能键盘操作。
 * 这里只补三件浏览器不白送的事:
 *   1. 点面板外面关掉
 *   2. Esc 关掉
 *   3. 抽屉开着时锁住页面滚动
 */
(function () {
  'use strict';

  var header = document.querySelector('[data-trips-header]');
  if (!header) return;

  var panels = header.querySelectorAll('details[data-trips-dropdown], details[data-trips-drawer]');
  var drawer = header.querySelector('details[data-trips-drawer]');

  function closeAll(except) {
    panels.forEach(function (panel) {
      if (panel !== except) panel.open = false;
    });
  }

  panels.forEach(function (panel) {
    panel.addEventListener('toggle', function () {
      if (panel.open) closeAll(panel);
      if (drawer) {
        document.body.classList.toggle('trips-drawer-open', drawer.open);
      }
    });
  });

  document.addEventListener('click', function (event) {
    panels.forEach(function (panel) {
      if (!panel.open) return;
      // 遮罩是 details 的伪元素,点它事件落在 details 上 —— 所以这里判断的是
      // 「有没有点在真正的内容里」,不是「有没有点在 details 里」
      var inner = panel.querySelector('.trips-dropdown, .trips-drawer__panel');
      var summary = panel.querySelector('summary');
      if (inner && inner.contains(event.target)) return;
      if (summary && summary.contains(event.target)) return;
      panel.open = false;
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var wasOpen = null;
    panels.forEach(function (panel) {
      if (panel.open) wasOpen = panel;
    });
    if (!wasOpen) return;
    wasOpen.open = false;
    // 关掉后把焦点还给触发它的 summary,否则焦点掉到 body 上
    var summary = wasOpen.querySelector('summary');
    if (summary) summary.focus();
  });
})();
